import { useConductorComponent } from "@faire/deprecated-retailer-visitor-shared/features/Conductor/useConductorComponent";
import { ConductorSurface } from "@faire/web-api--source/indigofair/data/ConductorSurface";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";

export const useConductorGate: IGateHook = () => {
  const modalType = useModalType();
  const { conductorBuilderModelName, conductorSduiViewLayout } =
    useConductorComponent({ surface: ConductorSurface.SITE_WIDE_MODAL });

  const isConductorModal =
    !!conductorBuilderModelName || !!conductorSduiViewLayout?.content?.length;

  if (isConductorModal || modalType === PromoModalType.CONDUCTOR_MODAL) {
    return PromoModalType.CONDUCTOR_MODAL;
  }

  return undefined;
};
